import React from 'react';
import PropTypes from 'prop-types';
import Loading from '../../component/Loading/Loading';
import Notify from "../../services/Notify";
import TransactionService from "../TransactionService";
import Box from "../../component/Box/Box";
import { Col, Row } from "react-bootstrap";
import { dayMonthYearAtTime, timeago } from "../../utils/dates";

import ByondGrid2 from '../../customGrid/CustomGrid'
import TransactionItemGrid from "../../customGrid/entities/TransactionItemGrid";
import TabComponent from '../../component/Tab/TabComponent';
import ProductTypesTabGrid from '../../customGrid/entities/ProductTypeTabGrid';
import LoadingV2 from '../../component/Loading/LoadingV2'
import ProductTypeSelector, { mapItems } from '../../productType/component/ProductTypeSelector';
import CheckboxWithLabel from '../../component/Checkbox/CheckBoxWithLabel';
import {TransactionStatusTranslate} from "../../component/Transaction/TransactionStatusTranslate";

class TransactionView extends React.Component {

  service = new TransactionService();

  constructor(props) {
    super(props);
    this.state = { entity: {}, onlyWrongWorkflowFilter: false };
    this.getHeader = this.getHeader.bind(this);
  }

  productTypeGrid = new ProductTypesTabGrid();

  transactionItemGrid = new TransactionItemGrid();

  componentDidMount() {
    const { match } = this.props;
    const id = match.params.id;
    const state = this.state;
    state.loading = true;
    this.setState(state);
    this.service.findById(id).then(
      data => this.setState(
        {
          loading: false,
          entity: data
        }),
      error => {
        const state = { loading: false };
        if (error.response.status === 404) {
          state.message = 'Entidade não encontrada!';
        } else {
          state.message = 'Erro inesperado!';
          Notify.error('Falha o buscar entidade!', error)
        }
        this.setState(state);
      }
    )
  }

    getHeader() {
    const {
      id,
      createdAt,
      readpoint,
      checkpoint,
      isManual,
      userCreatedBy,
      status,
      statusReason,
      reasonManualTransaction,
      movementOrder
    } = (this.state && this.state.entity) || {};

    return <Row>
      <Col md={6}>
        <p>Evento: {id}</p>
        <p>Data: {dayMonthYearAtTime(createdAt)}, {timeago(createdAt)}</p>
        <p>Ponto de Leitura: {readpoint && readpoint.friendlyName}</p>
        <p>Ponto de Controle: {checkpoint && checkpoint.friendlyName}</p>
        {movementOrder && <a href={`#/movement-order/${movementOrder.id}`}>Ordem de movimentação: {movementOrder.code}</a>}
      </Col>
      <Col md={6}>
        <p>Manual: {isManual ? "Sim" : "Não"}</p>
        <p>Status: {TransactionStatusTranslate(status)}</p>
        <p>Usuário: {userCreatedBy && userCreatedBy.name}</p>
        {statusReason ? <p>Motivo do Status: {statusReason}</p> : ''}
        {reasonManualTransaction && <p>Motivo da transação manual, pelo usuário: {reasonManualTransaction}</p>}
        {movementOrder && <p>Destino da Ordem de movimentação: {movementOrder.destination && movementOrder.destination.friendlyName}</p>}
      </Col>
    </Row>

  }

  render() {
    const { loading } = this.props;
    const { entity, onlyWrongWorkflowFilter } = this.state;

    if (loading || !entity.id) {
      return <Loading />;
    }

    const header = this.getHeader();

    const tabContent = [
      {
        title: 'Tipo de produto',
        content: (
          <ByondGrid2
            removeBox
            match={this.props.match}
            metadata={this.productTypeGrid}
            endpoint={this.productTypeGrid.endpoint(entity.id)}
            onClickInRow={(state, row) => {
              if (!row.original.productType) {
                return
              }
              this.setState({ tabIndex: 1, productTypeToFilter: row.original.productType })
            }}
          />
        )
      },
      {
        title: 'Detalhes dos itens',
        content: (
          <Row className="align-items-center">
            <Col md={4}>
              <ProductTypeSelector
                defaultValue={this.state.productTypeToFilter && mapItems(this.state.productTypeToFilter)}
                onChange={productTypeToFilter => this.setState({ productTypeToFilter })}
              />
            </Col>
            <Col md={6} className="mt-md-4">
              <CheckboxWithLabel label="Mostrar apenas itens com fluxo inválido" setValue={() => this.setState({onlyWrongWorkflowFilter: !onlyWrongWorkflowFilter})}/>
            </Col>
            <Col md={12}>
              <ByondGrid2
                removeBox
                endpoint={`${this.transactionItemGrid.endpoint(entity.id, this.state.productTypeToFilter && this.state.productTypeToFilter.id)}&onlyWorkFlowError=${onlyWrongWorkflowFilter}`}
                match={this.props.match}
                metadata={this.transactionItemGrid}
              />
            </Col>
          </Row>
        )
      },
    ]

    return (
      <div>
        <div className="box-transaction" title="Dados da transação">
          {header}
        </div>
        <Box info title="Detalhes da transação">
          <TabComponent content={tabContent} selectedTabIndex={this.state.tabIndex} onTabChange={tabIndex => this.setState({ tabIndex })} />
        </Box>
      </div>
    );
  }
}

TransactionView.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default TransactionView;



// WEBPACK FOOTER //
// ./src/transaction/component/TransactionView.js